<template>
  <template v-if="selectedCriteriaOptions.length > 0">
    <AtomicUiHorizontalFacets
      v-show="!isMobile"
      class="margin-top-xs"
      name="facet-chip"
      facet-style="chip"
      :options="selectedCriteriaOptions"
      @on-facet-click="selectedCriteriaFacetClick"
    />
  </template>
</template>

<script setup>
import { GET_ALL_SELECTED_CRITERIA, REPLACE_SELECTED_VALUES, REMOVE_CHECKBOX_VALUES_BY_VALUE } from '~/types/actions';
import useDisplay from '~/composables/filteringFacets/useDisplay';
import { useFilteringFacetsStore } from '~/stores/filteringFacets';

const { screen } = useDisplay();
const filteringFacetsStore = useFilteringFacetsStore();
const facets = computed(() => filteringFacetsStore.facets);
const getSelectedSortOrder = (value) => {
  const isPriceCategory = value.category.toLowerCase() === 'price';
  return isPriceCategory ? parseInt(value.id.replace(/$|\|.*/, ''), 10) : value.id;
};

const isMobile = computed(() => screen.value.isMobile);
const selectedCriteriaOptions = computed(() =>
  facets.value
    .filter((facet) => facet.selectedValues.length > 0)
    .map((facet) =>
      facet.selectedValues
        .map((selected) => {
          const displayName = facet.values.filter((value) => value.value === selected)[0].label;
          return {
            id: `${selected}`,
            closeable: true,
            contents: { text: displayName },
            category: facet.name,
          };
        })
        .sort((a, b) => {
          const aSortValue = getSelectedSortOrder(a);
          const bSortValue = getSelectedSortOrder(b);
          if (aSortValue > bSortValue) {
            return 1;
          } else if (aSortValue < bSortValue) {
            return -1;
          }
          return 0;
        }),
    )
    .flat(),
);

const selectedCriteriaFacetClick = (facet) => {
  const { category } = facet.selected;
  const selectedChip = facet.selected.id;
  filteringFacetsStore[REPLACE_SELECTED_VALUES]({
    name: category,
    selectedValues: filteringFacetsStore.facetByName(category).selectedValues.filter((value) => value !== selectedChip),
  });
  if (category === 'Price' && facet.selected.contents.text.indexOf('Custom') === 0) {
    filteringFacetsStore[REMOVE_CHECKBOX_VALUES_BY_VALUE]({
      name: category,
      value: selectedChip,
    });
  }
  filteringFacetsStore[GET_ALL_SELECTED_CRITERIA]();
};
</script>
